document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initSliders();
});

function initMobileMenu() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const navClose = document.querySelector('.header__nav-close');
  const nav = document.querySelector('.header__nav');

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function() {
      nav.classList.add('is-open');
      document.body.classList.add('menu-open');
    });
  }

  if (navClose && nav) {
    navClose.addEventListener('click', function() {
      nav.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    });
  }
}

function initSliders() {
  const mainSlider = document.querySelector('.main-visual__slider');
  if (mainSlider) {
    new Swiper(mainSlider, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: { delay: 4000, disableOnInteraction: false },
      loop: true,
      speed: 1000
    });
  }
  // Note: ranking slider uses custom JS in ranking.liquid, not Swiper
}
